import type { ServerResponseV1 } from "@/http"
import type { EventWebsiteDTOData, EventWebsiteResponse } from "@/models"
import * as Sentry from "@sentry/vue"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"
import { EventWebsiteSchemaV1 } from "@/models"

interface ICreateWebsiteFields {
  domainKey: string
  slug?: string
  isPublic: boolean
}

interface IUseCreateWebsiteArgs extends ICreateWebsiteFields {
  eventVaultId: number
}

export async function createWebsite(eventVaultId: number, fields: ICreateWebsiteFields): Promise<EventWebsiteDTOData> {
  const endpoint = `/events/${eventVaultId}/website`
  const response = await v1.post<ServerResponseV1<EventWebsiteResponse>>(endpoint, fields)

  const result = EventWebsiteSchemaV1.safeParse(response.data.data)

  if (!result.success) {
    const message = "Failed to validate API response schema"
    Sentry.logger.error(message, {
      raw: response.data.data,
      endpoint,
      body: fields,
      method: "post",
    })

    throw new Error(message)
  }

  return result.data
}

export function useCreateWebsite() {
  return useMutation({
    mutationFn: ({ eventVaultId, domainKey, slug, isPublic }: IUseCreateWebsiteArgs) => createWebsite(eventVaultId, {
      domainKey,
      slug,
      isPublic,
    }),
  })
}
